import * as Sentry from "@sentry/vue";
import { createPinia } from "pinia";
import { createApp } from "vue";

import "@/assets/styles/main.css";
import "virtual:vite-svg-2-webfont.css";

import App from "@/App.vue";
import { router } from "@/router";

const pinia = createPinia();
const appContainer = document.getElementById("app");
if (appContainer !== null) {
  const app = createApp(App);

  if (import.meta.env.PROD) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_VUE_SENTRY_DSN,
      environment: import.meta.env.VITE_VUE_SENTRY_ENVIRONMENT,
      release: import.meta.env.VITE_VUE_SENTRY_RELEASE,
    });
  }

  app.use(pinia);
  app.use(router);
  app.mount(appContainer);
}
